import snapshotApplicationState from './snapshotApplicationState.js'
import dmpgChangeHandlers from './changeHandlers/index.js'

export default function (dataLayer, cartId) {
  const myCache = []
  myCache.history = []

  function send (event) {
    myCache.push(event)
    if (event.event === 'stage_changed') {
      flush()
    }
  }

  function sendImmediately (event) {
    dataLayer.push(event)
  }

  function flush () {
    myCache.splice(0,myCache.length).forEach( (event) => {
      dataLayer.push(event)
    })
  }

  return {
    sendFlightSearchCustomEvent () {
      sendImmediately({
        "event": "searchForFlights",
        "cart_id": cartId,
      })
    },

    sendEvents (app) {
      const newApplicationState = snapshotApplicationState(app, cartId)
      dmpgChangeHandlers.forEach((handler) => {
        handler
          .eventsFor(this.oldApplicationState, newApplicationState)
          .forEach(send)
      })

      this.oldApplicationState = newApplicationState
    },
    sendImmediately,
  }
}
